import { Radio } from 'antd';
import styled from 'styled-components';

export const DetailingProjectInputContainer = styled.div`
  &:not(:last-child) {
    margin-right: unset;
    margin-bottom: 1rem;
  }

  & > .description {
    font-size: 0.875rem;
    color: ${({ theme }) => theme.colors.grayDark2};
  }

  & > .title {
    color: ${({ theme }) => theme.colors.grayDark2};
    font-weight: bold;
    font-size: 0.875rem;
  }

  flex-grow: 1;

  &:not(:last-child) {
    margin-right: 1rem;
    margin-bottom: unset;
  }

  &.switch-container {
    height: 3.825rem;
    min-width: 8.25rem;
    flex-grow: unset;
  }

  &.select-project {
    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      width: 11.5rem;
    }
  }

  &.revision-container {
    max-width: 8.5rem;
    min-width: 8rem;
  }

  &.pavements-container {
    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      width: 14rem;
    }
    & .ant-select {
      width: 100%;
    }
  }

  &.repetitions-container {
    min-width: 7.5rem;
    max-width: 7.5rem;

    & input.increase-decrease-input {
      padding: 0.333rem 3.4rem;
    }
  }

  &.details-description {
    flex-grow: 1;
  }

  &.vehicle-type {
    width: unset;
  }

  & > .ant-radio-group > .product-type-radio {
    flex-direction: column;
    align-items: unset;

    & > .ant-space-item {
      margin-bottom: 0.5rem;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      flex-direction: row;
      align-items: center;

      & > .ant-space-item {
        margin-bottom: unset;
      }
    }
  }
`;

export const DetailingProjectItemContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  position: relative;
  transition: opacity 0.5s;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 1rem;
  }

  @media (min-width: 1190px) {
    padding: 1rem 0 0 0;
    flex-wrap: nowrap;
    & > div {
      width: 50%;
      &:first-child {
        margin-right: 1rem;
      }
    }
  }

  &.odd {
    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      background-color: ${({ theme }) => theme.colors.white2};
    }

    @media (min-width: 1190px) {
      background-color: unset;
    }
  }

  &.remove-element {
    opacity: 0;
  }

  animation: newItem 1s ease;
  @keyframes newItem {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 0.75;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const DetailingProjectBlock = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 0.25rem;
  padding: 0.75rem 0.75rem;
  margin: 0.75rem 0;

  padding: 1.25rem 1.75rem;
  margin: 0.5rem 0;

  & > span.subtitle {
    color: ${({ theme }) => theme.colors.grayDark4};
    font-family: ${({ theme }) => theme.fonts.workSans};
    font-size: 1rem;
  }

  & > .block-title {
    color: ${({ theme }) => theme.colors.black};
    font-weight: bold;
    font-size: 1.125rem;
  }

  & > .block-title-subtitle {
    font-weight: 700;
    font-size: 0.875rem;
  }

  & > .upload-project-options-text {
    font-size: 0.875rem;
    font-weight: 400;
  }

  & > .hefesto-chip .mdc-chip--selected {
    pointer-events: none;
  }
`;

export const DetailingProjectContentBlock = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-wrap: nowrap;
  }
`;

export const RadioGroup = styled(Radio.Group)`
  display: flex;
  flex-direction: row;

  & > .ant-radio-wrapper {
    margin-bottom: 0.5rem;
  }
`;

export const ProjectRevisionStatus = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
`;

export const FabricationSelectOptionStyle = styled.div`
  display: flex;
  flex-direction: column;
  border: 2px solid red;
`;

export const ObservationContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 1.25rem 1.75rem;

  textarea,
  .hefesto-textarea {
    width: 100%;
  }
`;

export const ButtonContainer = styled.div`
  position: sticky;
  bottom: 0;
  left: 0;
  z-index: 99;

  background-color: ${({ theme }) => theme.colors.white};
  margin-top: 0.5rem;
  display: flex;
  gap: 1rem;
  padding: 1.25rem 1.75rem;
  justify-content: flex-end;

  & > button {
    width: 20rem;
  }
`;
